<template>
    <section>
        <Breadcrumbs main="Hotlist Card" title="Hotlist Card" />
        <comingSoon/>
    </section>
</template>
<script>
  import comingSoon from '@/components/coming-soon.vue';
  export default {
    components: {
      comingSoon
    },
    data:() => ({
    }),
    mounted() {
    },
  };
</script>
<style scoped>
.comingsoon {
    min-height: 70vh !important;
}

</style>